import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { formatPriceTypeHourly } from 'src/containers/CartPage/utils';
import { skuByNewItemSelectorJS } from 'src/containers/AddSkuPage/selectors';

export default function AddSkuHeader({ name, itemDisplayPrice, showDiscountAppliedLater }) {
  const service = useSelector(skuByNewItemSelectorJS);

  return (
    <div className="flex justifyContentSpaceBetween alignItemsCenter paddingY-small1">
      <h3>{name}</h3>
      <h2 className="paddingLeft-small1">
        {formatPriceTypeHourly({ service, price: itemDisplayPrice })}
        {showDiscountAppliedLater && <span>*</span>}
      </h2>
    </div>
  );
}

AddSkuHeader.propTypes = {
  name: PropTypes.string.isRequired,
  itemDisplayPrice: PropTypes.string,
  showDiscountAppliedLater: PropTypes.bool,
};

AddSkuHeader.defaultProps = {
  itemDisplayPrice: '',
  showDiscountAppliedLater: false,
};
